// mutations
const SET_PAGINATION = (state, payload) => {
  state.page = payload;
};
const SET_PAGINATIONSTEP = (state, payload) => {
  state.stepIndex = payload;
};
const SET_COMPANYLIST = (state, payload) => {
  state.companyList = payload;
};
const SET_EDITFIELD = (state, payload) => {
  state.showEdit = payload;
};
const SET_TEMPUSERINFORMATION = (state, payload) => {
  state.tempUser = payload;
};
const SET_TEMPPAYMENT = (state, payload) => {
  state.tempPayment = payload;
};
const SET_TEMPBANK = (state, payload) => {
  state.tempBank = payload;
};
const SET_RESULTGRADE = (state, payload) => {
  state.resultGrade = payload;
};
const SET_RESULTCOSTCENTER = (state, payload) => {
  state.resultCostCenter = payload;
};
const SET_RESULTWORKLOCATION = (state, payload) => {
  state.resultWorkLoc = payload;
};
const SET_TEMPOTHERINFO = (state, payload) => {
  state.tempOther = payload;
};
const SET_RESUTKARYAWAN = (state, payload) => {
  state.resultKaryawan = payload;
};
const SET_IDDELETEUSER = (state, payload) => {
  state.idDeleteUser = payload;
};
const SET_RESULTMASTERKARYAWAN = (state, payload) => {
  state.resultMasterKaryawan = payload;
};
const SET_RESULTCUTI = (state, payload) => {
  state.resultCuti = payload;
};
const SET_RESULTSEARCH = (state, payload) => {
  state.searchKaryawan = payload;
};
const SET_TEMPDATAHCUTI = (state, payload) => {
  state.tempJatahCuti = payload;
};
const SET_IDCUTI = (state, payload) => {
  state.idCuti = payload;
};
const SET_RESULTEDITCUTI = (state, payload) => {
  state.resultEditCuti = payload;
};
const SET_RESULTCOST = (state, payload) => {
  state.resultCost = payload;
};
const SET_RESULTCOSTEDIT = (state, payload) => {
  state.resultCostEdit = payload;
};
const SET_IDCOST = (state, payload) => {
  state.idcost = payload;
};
const SET_TEMPCOST = (state, payload) => {
  state.tempCost = payload;
};
const SET_RESULTMASTERGRADE = (state, payload) => {
  state.resultMasterGrade = payload;
};
const SET_TEMPJOBGRADE = (state, payload) => {
  state.tempJobgrade = payload;
};
const SET_IDJOBGRADE = (state, payload) => {
  state.idJobgrade = payload;
};
const SET_RESULTEDITJOB = (state, payload) => {
  state.res_jobgrade = payload;
};
const SET_RESULTMASTERPOSITION = (state, payload) => {
  state.resultMasterPosition = payload;
};
const SET_TEMPPOSITION = (state, payload) => {
  state.tempPosition = payload;
};
const SET_IDPOSITION = (state, payload) => {
  state.idPosition = payload;
};
const SET_RESULTEDITPOSITION = (state, payload) => {
  state.resPosition = payload;
};
const SET_RESULTROLE = (state, payload) => {
  state.resultRole = payload;
};
const SET_RESULTROLEEDIT = (state, payload) => {
  state.res_roleEdit = payload;
};
const SET_RESULTMENUS = (state, payload) => {
  state.res_menus = payload;
};
const SET_TEMPROLE = (state, payload) => {
  state.tempROle = payload;
};
const SET_IDROLE = (state, payload) => {
  state.idROle = payload;
};
const SET_RESSTORE = (state, payload) => {
  state.resStore = payload;
};
const SET_RESEXPORTKARYAWAN = (state, payload) => {
  state.exportKaryawan = payload;
};
const SET_SEARCH = (state, payload) => {
  state.search = payload;
};
const SET_MASTER_CAREER_TRANSISITION = (state, payload) => {
  state.master_career_transisiton = payload;
};
const SET_RESULTMASTERTAX = (state, payload) => {
  state.resultMasterTax = payload;
};
const SET_RESULTMASTERDEPARTEMEN = (state, payload) => {
  state.resultMasterDepartemen = payload;
};
const SET_TEMPTAX = (state, payload) => {
  state.tempTax = payload;
};
const SET_IDTAX = (state, payload) => {
  state.idTax = payload;
};
const SET_RESULTEDITTAX = (state, payload) => {
  state.resTax = payload;
};
const SET_IDDEPARTEMEN = (state, payload) => {
  state.idDepartemen = payload;
};
const SET_RESULTEDITDEPARTEMEN = (state, payload) => {
  state.resDepartemen = payload;
};
const SET_TEMPDEPARTEMEN = (state, payload) => {
  state.tempDepartemen = payload;
};
export default {
  SET_RESULTMASTERTAX,
  SET_RESULTMASTERDEPARTEMEN,
  SET_RESULTEDITDEPARTEMEN,
  SET_TEMPTAX,
  SET_TEMPDEPARTEMEN,
  SET_IDTAX,
  SET_RESULTEDITTAX,
  SET_SEARCH,
  SET_MASTER_CAREER_TRANSISITION,
  SET_PAGINATION,
  SET_COMPANYLIST,
  SET_RESULTROLEEDIT,
  SET_IDROLE,
  SET_TEMPROLE,
  SET_RESULTMENUS,
  SET_RESULTROLE,
  SET_RESULTEDITJOB,
  SET_IDJOBGRADE,
  SET_TEMPJOBGRADE,
  SET_RESULTMASTERGRADE,
  SET_RESULTCOSTEDIT,
  SET_TEMPCOST,
  SET_IDCOST,
  SET_RESULTCOST,
  SET_RESULTEDITCUTI,
  SET_IDCUTI,
  SET_RESULTCUTI,
  SET_IDDELETEUSER,
  SET_RESUTKARYAWAN,
  SET_PAGINATIONSTEP,
  SET_EDITFIELD,
  SET_TEMPUSERINFORMATION,
  SET_TEMPPAYMENT,
  SET_TEMPBANK,
  SET_RESULTGRADE,
  SET_RESULTCOSTCENTER,
  SET_RESULTWORKLOCATION,
  SET_TEMPOTHERINFO,
  SET_RESULTSEARCH,
  SET_TEMPDATAHCUTI,
  SET_RESULTMASTERKARYAWAN,
  SET_RESULTMASTERPOSITION,
  SET_TEMPPOSITION,
  SET_IDPOSITION,
  SET_IDDEPARTEMEN,
  SET_RESULTEDITPOSITION,
  SET_RESSTORE,
  SET_RESEXPORTKARYAWAN
};
